module.exports = __webpack_public_path__ + "img/arrow_down_black.ae453084.svg";